import {fetchGet} from "../../requests/NetworkRequestAuth0";
import {uri} from "./AppRequest";

export const getUserVenueRewards = (
    venueId,
    userCode,
    successMethod,
    errorMethod,
    getAccessToken
) => {
    fetchGet(
        uri + "/venue/" + venueId + "/user/" + userCode + "/rewards",
        successMethod,
        errorMethod,
        getAccessToken);
};

export const getUserVenueReward = (
    venueId,
    successMethod,
    errorMethod,
    getAccessToken
) => {
    fetchGet(
        uri + "/user/venue/" + venueId + "/rewards",
        successMethod,
        errorMethod,
        getAccessToken);
};